var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDA50D",
    d: "M14.056 0H.944C.424 0 0 .332 0 .744v15.658c0 .357.276.5.397.546.068.025.173.052.303.052.156 0 .3-.04.426-.12l6.36-2.916h.021c.018.012.036.02.056.028l6.258 2.86c.156.098.323.146.494.146.126 0 .226-.028.288-.05.12-.046.397-.187.397-.546V.744c0-.41-.423-.744-.944-.744z",
    transform: "rotate(90 11.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B500",
    d: "M13.125 1v13.656l-5.574-2.404c-.19-.092-.424-.144-.664-.144-.235 0-.451.047-.61.136L1.143 15 1.125 1.341l12-.341z",
    transform: "rotate(90 11.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC7A",
    d: "M13 1v.975l-5.574-.171c-.19-.007-.424-.01-.664-.01-.235 0-.451.003-.61.01L1.018 2 1 1.024 13 1z",
    transform: "rotate(90 11.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC7A",
    d: "M13 11h-1.95l.343-4.645c.013-.158.02-.353.02-.554 0-.195-.007-.375-.02-.507L11 1.015 12.951 1 13 11z",
    transform: "rotate(90 11.5 11.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.46478f4b315de510e2bfad5c6270da1c.svg";
export { ForwardRef as ReactComponent };